import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { AccordionItem } from 'components/atoms/Accordion';

import './accordion.scss';

export function Accordion({ className, content, faqSchema, isFAQ, preserve }) {
	return (
		<div className={classnames(className, 'accordion')}>
			<div>
				{content.map(({ question, answer, link }) => (
					<AccordionItem
						question={question}
						answer={answer}
						link={link}
						key={question}
						isFAQ={isFAQ}
						preserve={preserve}
					/>
				))}
			</div>
			{!isEmpty(faqSchema) && (
				<script
					key="schema"
					type="application/ld+json"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: faqSchema,
					}}
				/>
			)}
		</div>
	);
}

Accordion.propTypes = {
	className: PropTypes.string,
	accordionTitle: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	faqSchema: PropTypes.string,
	isFAQ: PropTypes.bool,
	preserve: PropTypes.bool,
};

Accordion.defaultProps = {
	content: [],
	preserve: false,
};

export default Accordion;
